import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'umi';
// import { List } from 'antd';
import { get, isEmpty, debounce, head } from 'lodash';
import moment from 'moment';
import cl from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Text, Tabs, Icon } from '@digitalc/dxp-ui';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';
import { BaseSpin } from '@/components';
import { getDeviceType } from '@/utils/utilsPoint';
import { numberFormat, dateFormat, formatDate, getThemeImgByKey } from '@/utils/utils';

import Header from '../Header';
// 后续完善打包工具后，会自动引入样式，无需手动引入，目前如果样式不对的情况下，需要手动引入样式
import '@digitalc/dxp-ui/umd/dxp-ui.min.css';
import styles from './index.less';
// import newsImg from '@/assets/images/point/gomo_news.png';
import noDataImg from '@/assets/images/point/point_no_Data.png';
// import noDataImgGlobe from '@/assets/images/point/point_no_Data_globe.png';
// import topPointBg from '@/assets/images/point/globe_pointBg.png';

const PointHistory = porps => {
  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();

  const {
    queryChangeHisDXP,
    changeHis,
    pageInfoHis,
    getPointDetailDXP,
    isWeb,
    isMulPoints,
    pointDetail,
    pointAccountsInfo,
    loading,
    getConfigParamDXP,
    dxpToken,
  } = porps;

  // const [userInfo, setUserInfo] = useState({});
  // const [isSearchType, setSearchType] = useState(false);
  // const [clickType, setclickType] = useState(0);
  const [isShade, setShade] = useState(false);
  const [changeType, setChangeType] = useState(null);
  const [periodMonth, setPeriodMonth] = useState(0);
  const [hasScroll, setHasScroll] = useState(false);
  const [bgStatus, setBgStatus] = useState('loading');
  const pageRef = useRef(null);

  // const expirTtime = moment().add(1, 'y').locale('en').format('DD MMM YYYY HH:mm:ss');

  useEffect(() => {
    const img = new Image();
    img.src = getThemeImgByKey('pointsHistoryHeaderBg');

    img.onload = () => setBgStatus('loaded');
    img.onerror = () => setBgStatus('error');

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, []);

  useEffect(() => {
    const checkScroll = () => {
      if (pageRef.current) {
        const { scrollHeight, clientHeight } = pageRef.current;
        setHasScroll(scrollHeight > clientHeight); // 如果内容高度大于可见高度，则有滚动条
      }
    };
    checkScroll(); // 初次检查
    const debouncedCheckScroll = debounce(checkScroll, 100); // 100ms 防抖
    const container = pageRef.current;
    if (container) {
      container.addEventListener('scroll', debouncedCheckScroll); // 关键：监听容器滚动
      checkScroll(); // 初始化检测
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', debouncedCheckScroll); // 清理监听
      }
    };
  }, [changeType]);

  useEffect(() => {
    // 暂时修改
    // const initAppStr = window.clp?.getLoginInfo() || '{}';
    // const initApp = JSON.parse(initAppStr) || {};
    const payload = {
      paramCodeList: ['lms.point.his.duration'],
    };
    getConfigParamDXP(payload).then(data => {
      setPeriodMonth(data?.paramValue || 1);
      queryChangeHisDXP({
        startDate: dateFormat(
          moment()
            .add(1, 'days')
            .subtract(data?.paramValue || 1, 'months')
            .locale('en'),
        ),
        endDate: dateFormat(moment().add(1, 'days').locale('en')),
        pageIndex: 1,
        pageSize: 10,
      });
    });
    getPointDetailDXP({
      scopes: 'LATEST_EXPIRING_POINT',
    });
  }, []);

  const handleSearchType = key => {
    setChangeType(key === '1' ? null : key);
    setShade(false);
    const payload = {
      changeType: key === '1' ? null : key,
      startDate: dateFormat(moment().add(1, 'days').subtract(periodMonth, 'months').locale('en')),
      endDate: dateFormat(moment().add(1, 'days').locale('en')),
      pageIndex: 1,
      pageSize: 10,
    };
    if (key === '1') {
      delete payload.changeType;
    }
    queryChangeHisDXP(payload);
  };

  const loadMoreData = async () => {
    const payload = {
      startDate: dateFormat(
        moment()
          .add(1, 'days')
          .subtract(periodMonth || 1, 'months')
          .locale('en'),
      ),
      endDate: dateFormat(moment().add(1, 'days').locale('en')),
      pageIndex: pageInfoHis.pageIndex + 1,
      pageSize: 10,
      changeType: changeType === '1' ? null : changeType,
    };
    if (!payload.changeType) {
      delete payload.changeType;
    }
    queryChangeHisDXP(payload);
  };

  const items = [
    {
      key: '1',
      title: GCPI18n({ id: 'lb_dito_pointhistory_page_all_type' }),
    },
    {
      key: 'P',
      title: GCPI18n({ id: 'lb_dito_pointhistory_page_earnings' }),
    },
    {
      key: 'M',
      title: GCPI18n({ id: 'lb_dito_pointhistory_page_spending' }),
    },
  ];

  const findClosestDateObject = dateArr => {
    let closestObject = null;
    let smallestDiff = Infinity; // 初始设置为无限大

    dateArr.forEach(obj => {
      if (obj.expiringDate) {
        const objMoment = moment(obj.expiringDate);
        const now = moment();
        const diff = Math.abs(now.diff(objMoment));

        if (diff < smallestDiff) {
          smallestDiff = diff;
          closestObject = obj;
        }
      }
    });

    return closestObject;
  };

  const bgColor = dxpToken.colorBackgroundCtaInverse;
  const textColor = dxpToken.colorTextNeutral;

  return (
    <div
      ref={pageRef}
      id="scrollableDiv"
      className={cl(styles.pointHistoryWrap, isWeb && styles.webPointHistoryWrap, {
        [styles.androidPointHistory]: getDeviceType() === 'android',
      })}
    >
      <div className={isShade ? styles.shade : styles.noshade} />
      <Header
        title={GCPI18n({
          id: 'lb_header_my_point_hisotry_temp',
        })}
      />
      <BaseSpin spinning={loading}>
        <div
          className={cl(
            styles.pointsDetailBox,
            get(pointDetail, 'expiringPoint') ? null : styles.widthoutInfo,
          )}
          style={{
            height: 'auto',
            minHeight: isMulPoints && pointAccountsInfo?.length > 1 ? '1.64rem' : '1.36rem',
            backgroundImage:
              bgStatus === 'loaded' ? `url(${getThemeImgByKey('pointsHistoryHeaderBg')})` : 'none',
            backgroundColor: bgStatus === 'error' ? bgColor : 'transparent',
            paddingTop: `${dxpToken.spacingGapLg / 100}rem`,
            paddingBottom: `${dxpToken.spacingGapXl / 100}rem`,
            marginBottom: `${dxpToken.spacingGapMd / 100}rem`,
          }}
        >
          {isMulPoints && pointAccountsInfo?.length > 1 ? (
            <div className={styles.bgContent}>
              {pointAccountsInfo.map(item => (
                <div className={styles.pointAcctWrap}>
                  <div className={styles.pointName}>
                    <Text breakpoint="Mobile" size="ContentC12Regular" style={{ color: textColor }}>
                      {item.pointAccountTypeName}
                    </Text>
                  </div>
                  <div className={styles.pointAcctValueWrap}>
                    <Text breakpoint="Mobile" size="TitleT21Bold" style={{ color: textColor }}>
                      {numberFormat(item.usablePointDisplay)}
                    </Text>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <>
              <Text breakpoint="Mobile" size="ContentC12Regular" style={{ color: textColor }}>
                {GCPI18n({
                  id: 'lb_points_my_remaining_points',
                })}
              </Text>
              <div
                className={styles.pointsNum}
                style={{ marginTop: `${dxpToken.spacingGapXs / 100}rem` }}
              >
                <Text breakpoint="Mobile" size="ContentC23Bold" style={{ color: textColor }}>
                  {numberFormat(get(pointDetail, 'usablePointDisplay') || 0)}
                </Text>
              </div>
            </>
          )}

          {Number(get(pointDetail, 'expiringPoint') || 0) ? (
            <div
              className={styles.pointsInfo}
              style={{ marginTop: `${dxpToken.spacingGapSm / 100}rem` }}
            >
              {/* <img src={newsImg} alt="" /> */}
              <Icon
                size={20}
                type="icon-Announcement"
                style={{ marginRight: `${dxpToken.spacingGapXs / 100}rem`, color: textColor }}
              />
              <Text breakpoint="Mobile" size="ContentC12Regular" style={{ color: textColor }}>
                <span>
                  {GCPI18n(
                    {
                      id: 'lb_points_expire_tip',
                    },
                    {
                      pointValue: numberFormat(
                        get(
                          head(
                            get(
                              pointAccountsInfo.length > 1
                                ? findClosestDateObject(pointAccountsInfo)
                                : pointDetail,
                              'latestExpiringPointList',
                            ),
                          ),
                          'expiringPoint',
                        ) || 0,
                      ),
                      expDate: get(
                        head(
                          get(findClosestDateObject(pointAccountsInfo), 'latestExpiringPointList'),
                        ),
                        'expiringDate',
                      )
                        ? formatDate(
                          get(
                            head(
                              get(
                                findClosestDateObject(pointAccountsInfo),
                                'latestExpiringPointList',
                              ),
                            ),
                            'expiringDate',
                          ),
                        )
                        : '',
                      effDate: get(
                        head(
                          get(findClosestDateObject(pointAccountsInfo), 'latestExpiringPointList'),
                        ),
                        'effDate',
                      )
                        ? formatDate(
                          get(
                            head(
                              get(
                                findClosestDateObject(pointAccountsInfo),
                                'latestExpiringPointList',
                              ),
                            ),
                            'effDate',
                          ),
                        )
                        : '',
                    },
                  )}
                </span>
              </Text>
            </div>
          ) : null}
        </div>
        <div className={styles.pointHistory}>
          {/* <div className={styles.pointsType}>
            <Radio.Group onChange={handleSearchType} value={changeType}>
              <Radio.Button value={null}>{GCPI18n({ id: 'DITO_POINTHISTORY_PAGE_ALL_TYPE' })}</Radio.Button>
              <Radio.Button value="P">
                {GCPI18n({
                  id: 'DITO_POINTHISTORY_PAGE_EARNINGS',
                })}
              </Radio.Button>
              <Radio.Button value="M">
                {GCPI18n({
                  id: 'DITO_POINTHISTORY_PAGE_SPENDING',
                })}
              </Radio.Button>
            </Radio.Group>
          </div> */}
          <Tabs defaultActiveKey="1" items={items} onChange={handleSearchType} />
          {/* <ListItem>
            test
          </ListItem> */}
          {pageRef.current && (
            <InfiniteScroll
              dataLength={changeHis.length}
              next={loadMoreData}
              hasMore={changeHis.length < get(pageInfoHis, 'totalCount')}
              scrollableTarget={pageRef.current}
            >
              <div
                className={styles.historyList}
                style={{
                  paddingTop: `${dxpToken.spacingGapMd / 100}rem`,
                  paddingBottom: hasScroll ? '0rem' : '0.16rem',
                  gap: `${dxpToken.spacingGapLg / 100}rem`,
                }}
              >
                {!isEmpty(changeHis) ? (
                  changeHis.map((changeHisItem, index) => (
                    <div key={index} className={cl(styles.historyItem, styles.historyItem6133)}>
                      <div
                        className={styles.itemTop}
                        style={{
                          marginTop:
                            get(changeHisItem, 'pointAcctTypeName') && isMulPoints
                              ? '0.08rem'
                              : '0rem',
                        }}
                      >
                        <Text
                          style={{ flex: 1, color: dxpToken.colorTextNeutral }}
                          breakpoint="Mobile"
                          size="ContentC14Bold"
                        >
                          {get(changeHisItem, 'businessType') === 'I'
                            ? `${GCPI18n({ id: 'lb_balance_to_points' })} ${get(
                              changeHisItem,
                              'ledgerBalanceToPointsName',
                            )}`
                            : get(changeHisItem, 'pointExchObjName') || '----'}
                          {get(changeHisItem, 'transactionType') === '4' && ' out'}
                          {get(changeHisItem, 'transactionType') === '5' && ' in'}
                        </Text>
                        <Text
                          breakpoint="Mobile"
                          size="ContentC14Bold"
                          style={{ color: dxpToken.colorTextCta }}
                        >
                          {get(changeHisItem, 'changeType') === 'M'
                            ? `- ${numberFormat(get(changeHisItem, 'amount'))}`
                            : `+ ${numberFormat(get(changeHisItem, 'amount'))}`}
                        </Text>
                      </div>
                      {get(changeHisItem, 'businessType') === 'M' &&
                        get(changeHisItem, 'ledgerBalanceToPointsName') && (
                          <div>
                            <Text
                              breakpoint="Mobile"
                              size="ContentC14"
                              style={{ color: dxpToken.colorTextNeutral }}
                            >
                              {get(changeHisItem, 'ledgerBalanceToPointsName')}
                            </Text>
                          </div>
                      )}

                      <div
                        className={styles.itemBottom}
                        style={{ color: dxpToken.colorTextSubtle }}
                      >
                        <Text breakpoint="Mobile" size="ContentC12Regular">
                          {get(changeHisItem, 'date') ? formatDate(get(changeHisItem, 'date')) : ''}
                        </Text>
                        {get(changeHisItem, 'transactionType') === '4' && (
                          <Text breakpoint="Mobile" size="ContentC12Regular">{`Receiver: ${get(
                            changeHisItem,
                            'receiver',
                          )}`}
                          </Text>
                        )}
                        {get(changeHisItem, 'transactionType') === '5' && (
                          <Text breakpoint="Mobile" size="ContentC12Regular">{`Sender: ${get(
                            changeHisItem,
                            'transferor',
                          )}`}
                          </Text>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    {!loading && (
                      <div className={styles.searchEmpty} style={{ paddingTop: '0rem' }}>
                        <img src={getThemeImgByKey('orderEmpty') || noDataImg} alt="" />
                        <Text
                          style={{
                            marginBottom: `${dxpToken.spacingGapSm / 100}rem`,
                            color: dxpToken.colorTextNeutral,
                          }}
                          breakpoint="Mobile"
                          size="TitleT23Bold"
                        >
                          {GCPI18n({ id: 'lb_point_history_no_data' })}
                        </Text>
                        <Text
                          style={{ color: dxpToken.colorTextNeutral }}
                          breakpoint="Mobile"
                          size="ContentC14Regular"
                        >
                          {GCPI18n({ id: 'lb_point_history_no_data_message' })}
                        </Text>
                      </div>
                    )}
                  </>
                )}
              </div>
              {hasScroll && (
                <div
                  className={styles.bottom}
                  style={{ marginTop: `${dxpToken.spacingGapLg / 100}rem` }}
                >
                  <span
                    style={{ backgroundColor: dxpToken.colorBorderDivider }}
                    className={styles.line}
                  />
                  {/* <span>{intl.formatMessage({ id: 'TASK_CENTER_MY_REWARD_LIST_END' })}</span> */}
                  <Text
                    style={{ margin: '0 0.16rem', color: dxpToken.colorTextSubtle }}
                    breakpoint="Mobile"
                    size="ContentC12Regular"
                  >
                    {GCPI18n({ id: 'lb_pointhistory_page_list_end' })}
                  </Text>
                  <span
                    style={{ backgroundColor: dxpToken.colorBorderDivider }}
                    className={styles.line}
                  />
                </div>
              )}
            </InfiniteScroll>
          )}
        </div>
      </BaseSpin>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
  queryChangeHisDXP: payload =>
    dispatch({
      type: 'pointShop/queryChangeHisDXP',
      payload,
    }),
  getPointDetailDXP: payload =>
    dispatch({
      type: 'pointShop/getPointDetailDXP',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading, index }) => ({
    changeHis: pointShop.changeHis,
    pageInfoHis: pointShop.pageInfoHis,
    pointDetail: pointShop.pointDetail,
    pointAccountsInfo: pointShop.pointAccountsInfo,
    isWeb: index.isWeb,
    isMulPoints: index.isMulPoints,
    dxpToken: index.dxpToken,
    loading: loading.effects['pointShop/queryChangeHisDXP'] || false,
  }),
  mapDispatchToProps,
)(PointHistory);
